import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import logo from '../assets/images/ZiyaratGuide.svg';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showShrinesDropdown, setShowShrinesDropdown] = useState(false);
  const [showImamMahdiDropdown, setShowImamMahdiDropdown] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setShowShrinesDropdown(false);
    setShowImamMahdiDropdown(false);
  };

  const toggleDropdown = (setter, event) => {
    event.stopPropagation();
    setter(prev => !prev);
  };

  const closeAllDropdowns = () => {
    setShowShrinesDropdown(false);
    setShowImamMahdiDropdown(false);
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand" onClick={closeAllDropdowns}>
          <img src={logo} alt="Ziyarat Guide Logo" className="navbar-logo" />
        </Link>

        <button className="hamburger-icon" onClick={toggleMobileMenu} aria-label="Toggle mobile menu">
          {isMobileMenuOpen ? <X size={28} color="white" /> : <Menu size={28} color="white" />}
        </button>

        {/* Desktop Links */}
        <div className="navbar-links desktop-links">
          <Link to="/" onClick={closeAllDropdowns}>Home</Link>

          {/* Shrines Dropdown */}
          <div
            className="dropdown-container"
            onMouseEnter={() => setShowShrinesDropdown(true)}
            onMouseLeave={() => setShowShrinesDropdown(false)}
          >
            <span className="dropdown-toggle">Holy Sites <ChevronDown size={16} /></span>
            {showShrinesDropdown && (
              <div className="dropdown-menu">
                <Link to="/shrines/shrine-of-imam-hussain" className="dropdown-item ml-4" onClick={closeAllDropdowns}>Imam Hussain (PBUH) Shrine</Link>
                <Link to="/shrines/al-abbas-shrine" className="dropdown-item ml-4" onClick={closeAllDropdowns}>Al Abbas (PBUH) Shrine</Link>
                <Link to="/shrines/al-mukhayam-shrine" className="dropdown-item ml-4" onClick={closeAllDropdowns}>Al-Mukhayam Shrine</Link>
                <Link to="/shrines/shrine-of-two-sons-muslim-ibn-aqeel" className="dropdown-item ml-4" onClick={closeAllDropdowns}>Sons of Muslim ibn Aqeel</Link>
              </div>
            )}
          </div>

          {/* Imam Mahdi Dropdown */}
          <div
            className="dropdown-container"
            onMouseEnter={() => setShowImamMahdiDropdown(true)}
            onMouseLeave={() => setShowImamMahdiDropdown(false)}
          >
            <Link
              to="/imam-mahdi"
              className="dropdown-toggle no-underline"
              onClick={closeAllDropdowns}
            >
              Imam Mahdi (ajtf) <ChevronDown size={16} />
            </Link>
            {showImamMahdiDropdown && (
              <div className="dropdown-menu">
                <Link to="/imam-mahdi/ultimate-reformer" className="dropdown-item" onClick={closeAllDropdowns}>Ultimate Reformer</Link>
                <Link to="/imam-mahdi/why-occultation" className="dropdown-item" onClick={closeAllDropdowns}>Why Occultation</Link>
                <Link to="/imam-mahdi/described-in-quran-hadith" className="dropdown-item" onClick={closeAllDropdowns}>In Quran & Hadith</Link>
                <Link to="/imam-mahdi/return" className="dropdown-item" onClick={closeAllDropdowns}>His Return</Link>
                <Link to="/imam-mahdi/supporters" className="dropdown-item" onClick={closeAllDropdowns}>His Supporters</Link>
                <Link to="/imam-mahdi/impact-appearance" className="dropdown-item" onClick={closeAllDropdowns}>Global Impact</Link>
                <Link to="/imam-mahdi/misconceptions" className="dropdown-item" onClick={closeAllDropdowns}>Misconceptions</Link>
                <Link to="/imam-mahdi/practices-allegiance" className="dropdown-item" onClick={closeAllDropdowns}>Practices of Allegiance</Link>
                <Link to="/imam-mahdi/reflections-stories" className="dropdown-item" onClick={closeAllDropdowns}>Reflections & Stories</Link>
                <Link to="/imam-mahdi/signs-reappearance" className="dropdown-item" onClick={closeAllDropdowns}>Signs of Reappearance</Link>
                <Link to="/imam-mahdi/how-to-talk" className="dropdown-item" onClick={closeAllDropdowns}>How to Talk to Him</Link>
              </div>
            )}
          </div>

          {/* Guides Link */}
          <Link to="/guides" onClick={closeAllDropdowns}>Guides</Link>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`mobile-menu ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
        <button className="close-menu-icon" onClick={toggleMobileMenu} aria-label="Close mobile menu">
          <X size={32} />
        </button>
        <Link to="/" onClick={closeAllDropdowns}>Home</Link>

        {/* Mobile Shrines Dropdown */}
        <div className="mobile-dropdown-parent">
          <span className="dropdown-toggle" onClick={(e) => toggleDropdown(setShowShrinesDropdown, e)}>
            Holy Sites <ChevronDown size={16} className={`transition-transform ${showShrinesDropdown ? 'rotate-180' : ''}`} />
          </span>
          {showShrinesDropdown && (
            <div className="mobile-dropdown-menu">
              <Link to="/shrines/shrine-of-imam-hussain" className="ml-4" onClick={closeAllDropdowns}>Imam Hussain (PBUH) Shrine</Link>
              <Link to="/shrines/al-abbas-shrine" className="ml-4" onClick={closeAllDropdowns}>Al Abbas (PBUH) Shrine</Link>
              <Link to="/shrines/al-mukhayam-shrine" className="ml-4" onClick={closeAllDropdowns}>Al-Mukhayam Shrine</Link>
              <Link to="/shrines/shrine-of-two-sons-muslim-ibn-aqeel" className="ml-4" onClick={closeAllDropdowns}>Sons of Muslim ibn Aqeel</Link>
            </div>
          )}
        </div>

        {/* Mobile Imam Mahdi Dropdown */}
        <div className="mobile-dropdown-parent">
          <span className="dropdown-toggle" onClick={(e) => toggleDropdown(setShowImamMahdiDropdown, e)}>
            Imam Mahdi (ajtf) <ChevronDown size={16} className={`transition-transform ${showImamMahdiDropdown ? 'rotate-180' : ''}`} />
          </span>
          {showImamMahdiDropdown && (
            <div className="mobile-dropdown-menu">
              <Link to="/imam-mahdi/ultimate-reformer" onClick={closeAllDropdowns}>Ultimate Reformer</Link>
              <Link to="/imam-mahdi/why-occultation" onClick={closeAllDropdowns}>Why Occultation</Link>
              <Link to="/imam-mahdi/described-in-quran-hadith" onClick={closeAllDropdowns}>In Quran & Hadith</Link>
              <Link to="/imam-mahdi/return" onClick={closeAllDropdowns}>His Return</Link>
              <Link to="/imam-mahdi/supporters" onClick={closeAllDropdowns}>His Supporters</Link>
              <Link to="/imam-mahdi/impact-appearance" onClick={closeAllDropdowns}>Global Impact</Link>
              <Link to="/imam-mahdi/misconceptions" onClick={closeAllDropdowns}>Misconceptions</Link>
              <Link to="/imam-mahdi/practices-allegiance" onClick={closeAllDropdowns}>Practices of Allegiance</Link>
              <Link to="/imam-mahdi/reflections-stories" onClick={closeAllDropdowns}>Reflections & Stories</Link>
              <Link to="/imam-mahdi/signs-reappearance" onClick={closeAllDropdowns}>Signs of Reappearance</Link>
              <Link to="/imam-mahdi/how-to-talk" onClick={closeAllDropdowns}>How to Talk to Him</Link>
            </div>
          )}
        </div>

        {/* Mobile Guides Link */}
        <Link to="/guides" onClick={closeAllDropdowns}>Guides</Link>
      </div>
    </nav>
  );
};

export default Navbar;
